module.exports = __webpack_public_path__ + "img/2022.4.f138b52e.jpg";